export const SURVEY_PAGE_HEADER = "Survey Template";
export const SURVEY_PAGE_SUBTITLE =
  "Surveys can be changed by contacting Kevin Broene at gritleadershipea@gmail.com";



// WEBPACK FOOTER //
// ./src/pages/director/survey/constants.ts